<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import AlbumDetails from '../../../components/albums/album-details'
import AlbumForm from '../../../components/albums/album-form'

import api from '../../../services/api'


/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Albums",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Layout,
    PageHeader,
    AlbumDetails,
    AlbumForm,
  },
  data() {
    const canEdit = !!JSON.parse(localStorage.getItem('user')).roles.find((v) => v.name === 'admin');

    return {
      title: "Albums",
      items: [
        {
          text: "Albums",
          active: true
        },
        {
          text: "Liste",
          active: true
        }
      ],
      canEdit,
      modalTitle: '',
      selectedAlbum: null,
      isBusy: false,
      displayDetails: false,
      displayEditForm: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "num_inventaire",
      sortDesc: false,
      fields: [
        {key: "num_inventaire", sortable: true, label: '#'},
        {key: "image", sortable: true, label: ''},
        {key: "titre", sortable: false, label: 'Titre'},
        {key: "volumes", sortable: false, label: 'Volumes'},
        {key: "actions", sortable: false, class: 'text-center'},
      ]
    };
  },
  computed: {},
  mounted() {
  },
  methods: {
    myProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be
      // handled by table itself
      //this.isBusy = true

      return api.get('albums', {
        page: ctx.currentPage,
        length: ctx.perPage,
        filter: ctx.filter,
        sortBy: ctx.sortBy,
        sortDir: (ctx.sortDesc ? 'desc' : 'asc'),
        with: 'volumes'
      }).then((response) => {
        const items = response.data.data
        // Here we could override the busy state, setting isBusy to false
        //this.isBusy = false

        this.totalRows = response.data.total;

        return (items)
      }).catch(() => {
        // Here we could override the busy state, setting isBusy to false
        //this.isBusy = false
        // Returning an empty array, allows table to correctly handle
        // internal busy state in case of error
        return []
      });
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    hideModal() {
      this.displayDetails = false;
      this.displayEditForm = false;
      this.selectedAlbum = null;
      this.modalTitle = '';

      this.$bvModal.hide('modal-details');
      this.$refs.albums_table.refresh();
    },
    showDetails(item) {
      this.displayDetails = true;
      this.displayEditForm = false;
      this.selectedAlbum = item;
      this.modalTitle = '<i class="bx bx-hash"></i> ' + item.num_inventaire;
    },
    showEditForm(item) {
      this.displayDetails = false;
      this.displayEditForm = true;
      this.selectedAlbum = item;
      this.modalTitle = '<i class="bx bx-hash"></i> ' + item.num_inventaire;
    },
  }
};
</script>

<template>
  <Layout>


    <PageHeader :title="title" :items="items"/>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Afficher&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;enregistrements
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-8">
                <div id="tickets-table_filter" class="dataTables_filter text-right">
                  <label class="d-inline-flex align-items-center">
                    Recherche :
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Recherche..."
                        class="form-control-sm w-auto"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  ref="albums_table"
                  :items="myProvider"
                  :fields="fields"
                  :busy.sync="isBusy"
                  striped
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  stacked="sm"
                  small
              >

                <template #cell(volumes)="data">
                  <ul class="list-inline" v-if="data.item.volumes">
                    <li class="list-inline-item" v-if="data.item.nom_volume">{{ data.item.nom_volume }}</li>
                    <li class="list-inline-item" v-for="volume in data.item.volumes" :key="volume.id">
                      {{ volume.nom_volume }}
                    </li>
                  </ul>
                </template>


                <template #cell(actions)="data">
                  <ul class="list-inline font-size-20 contact-links mb-0">
                    <li class="list-inline-item px-2 text-info">
                      <a v-b-modal.modal-details @click="showDetails(data.item)"
                         title="Afficher">
                        <i class="bx bx-show"></i>
                      </a>
                    </li>
                    <li v-if="canEdit" class="list-inline-item px-2 text-warning">
                      <a v-b-modal.modal-details @click="showEditForm(data.item)"
                         title="Modify">
                        <i class="bx bx-pencil"></i>
                      </a>
                    </li>
                  </ul>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
              <div class="col">
                <div class="float-end">
                  <strong>{{ totalRows }}</strong> enregistrements
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-details" :title-html="this.modalTitle" centered hide-footer
             size="xl"
             title-class="font-18"
             @hide="hideModal">
      <album-details v-if="displayDetails" :album="this.selectedAlbum"></album-details>

      <template v-if="canEdit">
        <album-form v-if="displayEditForm" :album="this.selectedAlbum" v-on:cancel="hideModal"
                    v-on:submitted="hideModal"></album-form>
      </template>
    </b-modal>
  </Layout>
</template>